export enum EWantTypeId {
  Sell = 'sell',
  Rent = 'rent',
}

export type TWantType = {
  id: EWantTypeId;
  text: string;
  imgClass: string;
};
